<div class="home-container">
  <!-- Seção de erro 404 (substitui o banner) -->
  <section class="error-banner-section">
    <div class="error-banner-content">
      <div class="error-text-section">
        <h1 class="error-title">
          <span class="title-line-1">{{ 'pages.notFound.titleLine1' | i18n }}</span>
          <span class="title-line-2">{{ 'pages.notFound.titleLine2' | i18n }}</span>
        </h1>
        <p class="error-description">
          {{ 'pages.notFound.description' | i18n }}
        </p>
      </div>
      
      <!-- Ilustração -->
      <div class="error-illustration">
        <img src="assets/images/404-notfound.png" alt="404 Not Found" class="error-image">
      </div>
      
      <!-- Seção "O que pode ter acontecido?" -->
      <div class="error-reasons">
        <h3 class="reasons-title">{{ 'pages.notFound.reasonsTitle' | i18n }}</h3>
        <ul class="reasons-list">
          <li>{{ 'pages.notFound.reasons.linkBroken' | i18n }}</li>
          <li>{{ 'pages.notFound.reasons.urlTypo' | i18n }}</li>
          <li>{{ 'pages.notFound.reasons.pageMoved' | i18n }}</li>
        </ul>
      </div>
      
      <button class="error-button" (click)="goHome()">
        <i class="material-icons">arrow_back</i>
        {{ 'pages.notFound.backHome' | i18n }}
      </button>
    </div>
  </section>

  <div class="home-content-container">
    <!-- Seção principal com produtos -->
    <section class="main-section">
      <div class="main-title-container font-highlight">
        <h2>
          {{ 'pages.notFound.offersTitle' | i18n }} 
          <span class="highlight">{{ 'pages.notFound.offersHighlight' | i18n }}</span>
        </h2>
      </div>
      <p class="main-description">
        {{ 'pages.notFound.offersDescription' | i18n }}
      </p>
    </section>

    <!-- Seção de tabs (categorias) -->
    <section class="tabs-section">
      <umkt-tabs [tabs]="tabs" [activeTabId]="activeTabIdSubject.value" (tabChange)="onCategoryChange($event)">
      </umkt-tabs>
    </section>

    <!-- Seção de produtos -->
    <section class="category-section" *ngIf="products.length > 0">
      <div class="category-header">
        <h3 class="category-title">{{ getCurrentCategory()?.name }}</h3>
        <p class="category-description">{{ getCurrentCategory()?.description }}</p>
      </div>
      <umkt-carousel [items]="products" id="not-found-products">
        <ng-template #itemTemplate let-product>
          <umkt-product-card
            [imageUrl]="product.imageUrl"
            [title]="product.name"
            [description]="product.excerpt"
            [priceLabel]="'pages.home.priceLabel' | i18n"
            [price]="product.price"
            [plans]="product.variations"
            [showAddToCart]="true"
            [showQuantitySelector]="true"
            [productType]="product.productType"
            [productSku]="product.sku"
            [customFields]="product.customFields"
            (learnMore)="onLearnMore(product)"
            (addToCart)="onAddToCartFromCard($event, product)"
            (click)="gtm.selectItem('404-page', getCurrentCategory()?.name || '404-page', { item_id: product.sku || product.uuid || product.id, item_name: product.name, item_category: getCurrentCategory()?.name || '404-page', price: product.salesPrice ?? product.price ?? 0 })"
          ></umkt-product-card>
        </ng-template>
      </umkt-carousel>
    </section>

    <!-- Seção de FAQ -->
    <section class="faq-section">
      <div class="faq-title-container">
        <h3 class="faq-title">{{ 'pages.notFound.faqTitle' | i18n }}</h3>
        <p class="faq-description">
          {{ 'pages.notFound.faqDescription' | i18n }}
        </p>
      </div>

      <!-- Desktop version -->
      <div class="faq-menu-container desktop-only">
        <h4 class="faq-menu-title">{{ getSelectedFaqItem()?.text }}</h4>
        <div class="faq-content">
          <umkt-list-item
            [items]="faqItems"
            [selectedItemId]="selectedFaqItem"
            [showDividers]="true"
            [textColor]="'var(--color-neutral-950-to-white)'"
            [padding]="'16px'"
            [fontSize]="'16px'"
            [fontWeight]="'400'"
            (itemSelected)="onFaqItemSelected($event)"
            [style.width]="'35%'"
          >
          </umkt-list-item>
          <umkt-collapse-panel
            [panels]="getSelectedFaqItem()?.questions"
            [leftIconClass]="'mdn-Icon-faq mdn-Icon--md'"
            [style.width]="'65%'"
          ></umkt-collapse-panel>
        </div>
      </div>

      <!-- Mobile version -->
      <div class="faq-mobile-container mobile-only">
        <select class="faq-mobile-select" [value]="selectedFaqItem" (change)="onFaqSelectChange($event)">
          <option value="" disabled>{{ 'pages.notFound.faqSelect' | i18n }}</option>
          <option *ngFor="let item of faqItems" [value]="item.id">
            {{ item.text }}
          </option>
        </select>
        <div class="faq-mobile-card" *ngIf="selectedFaqItem && selectedFaqItem !== ''">
          <div class="faq-mobile-header">
            <h4 class="faq-mobile-title">{{ getSelectedFaqItem()?.text }}</h4>
          </div>
          <div class="faq-mobile-content" *ngIf="getSelectedFaqItem()?.questions?.length > 0">
            <umkt-collapse-panel
              [panels]="getSelectedFaqItem()?.questions"
              [leftIconClass]="'mdn-Icon-faq mdn-Icon--md'"
            ></umkt-collapse-panel>
          </div>
          <div class="faq-mobile-content" *ngIf="!getSelectedFaqItem()?.questions?.length">
            <p class="faq-no-questions">{{ 'pages.notFound.faqNoQuestions' | i18n }}</p>
          </div>
        </div>
        <div class="faq-mobile-card" *ngIf="!selectedFaqItem || selectedFaqItem === ''">
          <div class="faq-mobile-header">
            <h4 class="faq-mobile-title">{{ 'pages.notFound.faqSelect' | i18n }}</h4>
          </div>
          <div class="faq-mobile-content">
            <p class="faq-select-prompt">{{ 'pages.notFound.faqPrompt' | i18n }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>